import { Image, Link, useMediaQuery } from '@chakra-ui/react';
import { useState } from 'react';

interface ICollabLogoProps {
  image: string;
  imageHover: string;
  url: string;
}

export const CollabLogo: React.FC<ICollabLogoProps> = (props): JSX.Element => {
  const { image, imageHover, url } = props;
  // eslint-disable-next-line use-encapsulation/prefer-custom-hooks
  const [selectedImage, setSelectedImage] = useState(image);
  const [isLargerThan768] = useMediaQuery('(min-width: 48em)');

  return (
    <Link href={url} target="_blank">
      <Image
        cursor="pointer"
        src={!isLargerThan768 ? imageHover : selectedImage}
        onMouseEnter={(): void => (isLargerThan768 ? setSelectedImage(imageHover) : undefined)}
        onMouseLeave={(): void => (isLargerThan768 ? setSelectedImage(image) : undefined)}
      />
    </Link>
  );
};
